import React, { useMemo } from 'react'
import styled from 'styled-components'
import { Form } from 'react-bootstrap'

const StyleListItem = styled.div`
  cursor: pointer;
  padding: 10px 25px;
  border-bottom: 1px solid #ddd;
    &:hover {
      background-color: #ECECEC ;
    }
  ${props => props.selected && `background-color: #ECECEC ;`}
`
const StyledFlexWrapper = styled.div`
  display:flex;
  justify-content:space-between;
  align-items: center;
  width: 100%;
  .leftSide{
    display:flex;
    flex-basis:70%;
  }
  .rightSide{
    display: flex;
    justify-content: flex-end;
    flex-basis:30%;
  }
  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
`
const Asset = ({ onClickSelectedAssets, selectedAssets, asset, index }) => {
    const isSelected = useMemo(() => selectedAssets.map(selectedAsset => selectedAsset.id).includes(asset.id), [asset.id, selectedAssets])

    return (
        <StyleListItem onClick={() => onClickSelectedAssets(asset, index)}
            selected={isSelected}
        >
            <StyledFlexWrapper>
                <div className="leftSide">
                    <div>
                        <h3>{asset.displayName}</h3>
                        <p>{asset.number}</p>
                    </div>
                </div>
                <div className="rightSide">
                    <Form.Check
                        type="checkbox"
                        id={`asset-${asset.id}`}
                        name="activityLevel.includeEndValue"
                        checked={isSelected}
                        onChange={() => onClickSelectedAssets(asset, index)}
                    />
                </div>
            </StyledFlexWrapper>
        </StyleListItem>
    )
}

export default Asset